import React from 'react';

const SidebarContext = React.createContext(null);

export default SidebarContext;


// WEBPACK FOOTER //
// ./src/lib/SidebarContext/index.js